module.exports = __webpack_public_path__ + "media/videos/video-main-0ac6e9eef71ac6c9c5488fd1a967bf95.webm";